import { inject, Injectable } from '@angular/core';
import { ObjectStorageService } from '@any2any/shared';
import { AuthState } from '../types/auth-state';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  public readonly data: {
    authState: AuthState | null;
    darkTheme: boolean;
    loginRedirectUrl: string | null;
    languageCode: string | null;
    devAuthSnapshot: {
      state: AuthState;
      platform: string;
    } | null;
  };

  constructor() {
    this.data = inject(ObjectStorageService).getLocalObject('general', {
      authState: null,
      darkTheme: false,
      loginRedirectUrl: null,
      languageCode: null,
      devAuthSnapshot: null,
    });
  }

  public clearAll(confirm?: boolean) {
    if (confirm) {
      this.data.authState = null;
      this.data.darkTheme = false;
      this.data.loginRedirectUrl = null;
      this.data.languageCode = null;
    }
  }

}
